import * as constants from './actions';

const initialState = {
    selectedAmount: 10,
    isCustomDonation: false,
    isCustomDonationDelay: false,
    isSubmitting: false,
    customAmount: '',
    mobileWizardStep: 1
};

function getTimeFrom(fromDate) {
    return (new Date() - fromDate) / 1000;
}

export default function donation(state = initialState, { type, payload }) {
    switch (type) {
        case constants.SELECT_AMOUNT:
            return {
                ...state,
                selectedAmount: payload,
                selectedAmountTime: new Date()
            };
        case constants.DONATE_MORE:
            return { ...state, isCustomDonation: payload };
        case constants.CUSTOM_AMOUNT_CHANGED:
            return { ...state, customAmount: payload };
        case constants.DONATION_SUCCESS:
            return {
                ...state,
                completeDonation: payload,
                actionCompleteTime: getTimeFrom(state.selectedAmountTime),
                actionIdentifier:
                    state.actionIdentifier !== undefined
                        ? [...state.actionIdentifier, payload.actionIdentifier]
                        : [payload.actionIdentifier]
            };
        case constants.SET_SUCCESS_INFO:
            return {
                ...state,
                successInfo: {
                    feedbackText: payload.feedbackText,
                    partnerName: payload.partnerName
                }
            };
        case constants.DONATION_SUBMITTING:
            return { ...state, isSubmitting: payload };
        case constants.MOBILE_GO_WIZARD_STEP:
            return { ...state, mobileWizardStep: payload };
        case constants.DONATION_SUBMITTING_ERROR:
            return { ...state, donationSubmitError: payload };
        case constants.DONATION_GO_BACK_TO_AMOUNT:
            return {
                ...state,
                cancelTime: getTimeFrom(state.selectedAmountTime)
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/Donation/reducer.js